import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { colors } from "../../../../ui/colors"
import { ArrowLeftIcon } from "../../../../ui/icons/arrow-left"
import { Layout } from "../../../../ui/layout"
import { ButtonComponent } from "../../../../ui/molecules/button/newButton"
import { Banner } from "../../../../ui/organisms/banner"
import { MenuItems } from "../../../../ui/organisms/navbar/dto"
import { PacDetailCreation, PACDetailValidation, resetPACDetailValidationStatus } from "../slice"
import { AddPACForms } from "./forms"

export function AddPAC() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const sessionState = useAppSelector(state => state.session)
    const pacState = useAppSelector(state => state.pac)

    useEffect(() => {
        if (pacState.PACDetailValidationStatus === 'successfully') {
            dispatch(resetPACDetailValidationStatus())
            dispatch(PacDetailCreation(pacState.PACDetailCreationRequest))
        }
    }, [pacState.PACDetailValidationStatus])

    useEffect(() => {
        if (pacState.PACDetailCreationStatus === 'successfully') {
            navigate('/pac')
        }
    }, [pacState.PACDetailCreationStatus])

    if (sessionState.selected.customerId) {
        return (
            <Layout
                menuItem={MenuItems.GESTIONE_CONTROLLO}
                breadcrumbItems={['Gestione Controllo', 'PAC', 'Nuovo PAC']}
                headerLabel="Nuovo Dettaglio PAC"
                rightBar={true}
                headerIcon={
                    <ArrowLeftIcon onClick={() => navigate('/pac')} color={colors.white} />
                }
                headerChildren={
                    <div className="flex items-center h-[100%] w-[100%] justify-end">
                        <ButtonComponent
                            size={"sm"}
                            iconPosition={"off"}
                            variant={"solid"}
                            label="Salva"
                            color={"orange"}
                            onClick={() => {
                                dispatch(PACDetailValidation(pacState.PACDetailCreationRequest))
                            }}
                        />
                    </div>
                }
            >
                <AddPACForms />
            </Layout>
        )
    }

    return (
        <Banner
            type="error"
            visible={!sessionState.selected.customerId}
            label={"Devi prima selezionare un cliente per accedere all'area"}
            closeAction={function (): void {
                alert("Devi prima selezionare un cliente per accedere all'area")
            }}
        />
    )
}